import { useWeb3Modal } from '@web3modal/ethers/react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { logo } from '../../assets/img';

const HomeHero = () => {
  const [showPopup, setShowPopup] = useState(false);
  const { open } = useWeb3Modal();

  const Route = useNavigate();
  
  const WalletAddress = localStorage.getItem("WalletAddress");

  const Validation = () => {
    if (WalletAddress) {
      Route("/upload");
    }
    else {
      setShowPopup(true);
    }
  }

  const closePopup = () => {
    setShowPopup(false);
  };
  return (
    <div>
      <div className="hero__1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="hero__left space-y-20">
                <h1 className="hero__title">
                Discover Digital Art and Collect NFT's
                </h1>
                <p className="hero__text txt">
                  DtoC is a shared liquidity NFT market smart contract which is
                  used by multiple websites to provide the users the best possible
                  experience.
                </p>
                <div
                  className="space-x-20 d-flex flex-column flex-md-row
							sm:space-y-20">
                  <Link className="btn btn-primary" to="/marketplace">
                    View market
                  </Link>
          
                  <div className="btn btn-white" onClick={Validation}>
                    Upload your item
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                className="img-fluid w-full"
                id="img_js"
                src="img/bg/in_hero1.png"
                alt="img"
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showPopup}
        onHide={()=>setShowPopup(false)}
        ariaHideApp={false}
        // size=""
        contentLabel="Example Modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <img src={logo} style={{ width: "8rem" }} alt="" />
          </Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <div className='m-4'>
            <h4>
            Please connect your wallet
            </h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
        <button className="btn btn-primary" onClick={() => { closePopup(); open() }}>
              Connect Wallet
            </button>
            <button className="btn btn-secondary" onClick={closePopup}>
              Close
            </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default HomeHero;
